import { useFixedHeadersStore } from '@diana/core';
import { isEqual } from 'lodash';

export interface IUseBuilderContentHeightProps {
  padding?: number;
  additionalHeight?: number;
}

export const useBuilderContentHeight = (props: IUseBuilderContentHeightProps = {}) => {
  const { padding = 32, additionalHeight = 0 } = props;
  const headerOffset = useFixedHeadersStore((s) => s.getTotalOffset(), isEqual);

  return `calc(100vh - ${headerOffset}px - ${padding}px - ${additionalHeight}px)`;
};
